import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export class DarkCountingNumbers {
  constructor() {
    this.darkCountingNumbers()
  }

  darkCountingNumbers() {
    const numbers = document.querySelectorAll('.dark-counting-numbers__number') as NodeListOf<HTMLElement>

    gsap.from(numbers, {
      scrollTrigger: '.dark-counting-numbers',
      textContent: 0,
      duration: 4,
      ease: 'power1.in',
      snap: { textContent: 1 },
      stagger: {
        each: 1.0,
        onUpdate: function() {
          this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent))
        },
      },
    })

    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
  }
}
